var layout_default = {
  "layout": "lnlTY",
  "cell": "hERiT"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
